import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var NEW_RELIC_SCRIPT = 'NEW_RELIC_SCRIPT';
export var NEW_RELIC_SCRIPT_SET = 'NEW_RELIC_SCRIPT_SET';